const mediaApiUrl = process.env.NEXT_PUBLIC_MEDIA_API_URL;

export default function TrackEvent(eventName: string, props: Map<string, string>) {
	if (typeof window === "undefined") {
		console.log("Tried to send analytics on the server");
		return;
	}

	if (
		process.env.NEXT_PUBLIC_BASE_URL == "http://localhost:3000" &&
		process.env.NEXT_PUBLIC_SEND_ANALYTICS == undefined || process.env.NEXT_PUBLIC_SEND_ANALYTICS == "false"
	) {
		// console.log("Event ignored: " + eventName);
		if (eventName == "Highlight View PP" || eventName == "Segment View") {
			//console.dir(props);
		}
		return;
	}
	// console.dir(props);

	const json: string[] = [];
	json.push(`{ "EventName": "${eventName}"`);

	props.forEach((value, key) => {
		json.push(`,"${key}":"${value}"`);
	});

	json.push("}");

	const body = json.join("");

	const success = navigator.sendBeacon(`${mediaApiUrl}/telemetry`, body);
	console.log("Event: ", eventName, success ? "sent" : "failed to send");
}